<template>
  <section class="progressTracker" v-if="steps.length > 0">
    <span
        v-for="(step, index) in steps"
        :key="step.name"
        :class="{ active: step.active, completed: step.completion > 99, step: true }">
      <span class="checkContainer">
        <i :class="{ completed: step.completion > 99 }" class="fa fa-check"></i>
      </span>
      <span class="bar base"></span>
      <span class="bar completion" :style="{width: step.completion + '%'}"></span>
      <a v-if="step.link"
         :href="step.link"
         class="stepName"><span>{{step.display}}</span></a>
      <span v-if="!step.link"
            @click="handleStepClick(step, index)"
            class="stepName">{{step.display}}</span>
    </span>
  </section>
</template>

<script>
  export default {
    name: 'ProgressTracker',
    props: {
      steps: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      handleStepClick: function(step, index) {
        /**
         * Event that fires when the user clicks on a step name.
         * 
         * @property {object} step the step object
         * @property {number} index the step index in the steps array
         */
        this.$emit('step-click', step, index);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .progressTracker {
    display: flex;
    flex-flow: row nowrap;
    margin: 15px auto;
    .step {
      flex: 1 0 100px;
      height: 75px;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: var(--foreground-medium); // was #8B8B8B; 3.36:1 on white
      position: relative;
      display: inline-block;
      .checkContainer {
        display: inline-block;
        height: 25px;
        font-size: 16px;
        color: var(--default-color);
        width: 100%;
        .fa {
          visibility: hidden;
        }
        .fa.completed {
          visibility: visible;
        }
      }
      .bar {
        display: inline-block;
        background-color: var(--default-color);
        opacity: .25;
        height: 6px;
        width: 100%;
        margin-top: 6px;
      }
      .bar.completion {
        position: absolute;
        top: 26px;
        left: 0px;
        opacity: 1;
        z-index: 3;
        width: 0px;
      }
      .stepName {
        margin: 8px 11px;
        height: 24px;
        display: inline-block;
        line-height: 12px;
        color: inherit;
      }

      a.stepName:hover {
        color: var(--default-color);
      }

      &.active {
        color: var(--text-color);
      }
      &.completed {
        color: var(--text-color);
      }
    }
    .step:first-of-type {
      .bar {
        border-top-left-radius: 24px;
        border-bottom-left-radius: 24px;
      }
    }
    .step:last-of-type {
      .bar {
        border-top-right-radius: 24px;
        border-bottom-right-radius: 24px;
      }
    }
  }
</style>
